export function encurtarNome(nome?: string): string {
    if (!nome) return ""
    const nomes = nome.split(" ")
    if (nomes.length <= 1) return nome
    const juncoes = ["de", "da", "do", "das", "dos"]
    const primeiroNome = nomes[0]
    const ultimoNome = nomes[nomes.length - 1]
    const nomesDoMeio = nomes.slice(1, nomes.length - 1)
    const nomesDoMeioAbreviados = nomesDoMeio
        .filter((nome) => !juncoes.includes(nome.toLowerCase()))
        .map((nome) => nome[0] + ".")
    return `${primeiroNome} ${nomesDoMeioAbreviados.join(" ")} ${ultimoNome}`
}


export function isUrl(url?: any) {
    if(!url) return false;
    try {
        new URL(url);
        return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_e:any) {
        return false;
    }
}